import React, { useEffect, useState } from "react";
import "./home.scss";
import { GoStar } from "react-icons/go";
import { GoStarFill } from "react-icons/go";
import { IoTrashBin } from "react-icons/io5";
import { MdOutlineFileUpload } from "react-icons/md";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";

const EditCustomerPrice = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const proId = searchParams.get("proId");
  const buyerId = searchParams.get("customerId");
  const typeList = ["normal", "featured", "offers", "trending"];
  const [name, setName] = useState("");
  const [selectBrand, setSelectBrand] = useState("");
  const [selectCategory, setSelectCategory] = useState("");
  const [selectType, setSelectType] = useState("");
  const [flashSale, setFlashSale] = useState("");
  const [price, setPrice] = useState("");
  const [oldPrice, setOldPrice] = useState("");
  const [stock, setStock] = useState("");
  const [barCode, setBarCode] = useState("");
  const [lrCode, setLrCode] = useState("");
  const [discount, setDiscount] = useState("");
  const [description, setDescription] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [outofstock, setOutofstock] = useState(false);
  const [proPhotos, setProPhotos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [customerPrice, setCustomerPrice] = useState([]);
  const [weight, setWeight] = useState("");
  const [perKg, setPerKg] = useState("");
  const [height, setHeight] = useState("");
  const [width, setWidth] = useState("");
  const [length, setLength] = useState("");
  const [newCustomerPrice, setNewCustomerPrice] = useState("");
  const [uom, setUom] = useState("");

  const oldCustomerPrice = customerPrice.find(
    (item) => item.customerId === buyerId || []
  );

  useEffect(() => {
    if (!proId) {
      return;
    }
    const getSingelProduct = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`/get-singale-product/${proId}`);
        setName(response.data.name);
        setSelectBrand(response.data.selectBrand);
        setSelectCategory(response.data.selectCategory);
        setSelectType(response.data.selectType);
        setFlashSale(response.data.flashSale);
        setPrice(response.data.price);
        setOldPrice(response.data.oldPrice);
        setStock(response.data.stock);
        setWeight(response.data.weight);
        setBarCode(response.data.barCode);
        setLrCode(response.data.lrCode);
        setDiscount(response.data.discount);
        setPerKg(response.data.perKg);
        setHeight(response.data.height);
        setWidth(response.data.width);
        setLength(response.data.length);
        setDescription(response.data.description);
        setOutofstock(response.data.outofstock);
        setProPhotos(response.data.proPhotos);
        setCustomerPrice(response.data.customerPrice);
      } catch (error) {
        return;
      } finally {
        setLoading(false);
      }
    };
    getSingelProduct();
  }, [proId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const newProduct = {
        name,
        brand: selectBrand,
        category: selectCategory,
        type: selectType,
        flashSale: flashSale === "yes",
        price: parseFloat(price),
        oldPrice: parseFloat(oldPrice),
        stock: parseInt(stock),
        barCode,
        lrCode,
        discount: parseFloat(discount),
        description,
        outofstock,
        proPhotos,
        weight,
        height,
        length,
        perKg,
        width,
      };

      const response = await axios.put(`/update-product/${proId}`, newProduct);
      navigate("/products");
    } catch (error) {
      return;
    }
  };

  useEffect(() => {
    const getCategory = async () => {
      try {
        const response = await axios("/get-category");
        setCategoryList(response.data);
      } catch (error) {
        return;
      }
    };
    getCategory();
  }, []);

  useEffect(() => {
    const getBrand = async () => {
      try {
        const response = await axios("/get-brand");
        setBrandList(response.data);
      } catch (error) {
        return;
      }
    };
    getBrand();
  }, []);

  setTimeout(() => {
    setSuccess(false);
  }, 1000);

  //! add product

  async function uploadPhoto(e) {
    const files = e.target.files;
    const data = new FormData();

    for (let i = 0; i < files.length; i++) {
      data.append("pro", files[i]);
    }
    await axios
      .post(`/proUploads`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        const { data: filenames } = response;
        setProPhotos((prev) => {
          return [...prev, ...filenames];
        });
      });
  }

  function removeDoc(e, filename) {
    e.preventDefault();
    setProPhotos([...proPhotos.filter((photo) => photo !== filename)]);
  }

  function selectMainPhoto(e, filename) {
    e.preventDefault();
    const addPhotoWithoutSelected = proPhotos.filter(
      (photo) => photo !== filename
    );
    const newAddedPhotos = [filename, ...addPhotoWithoutSelected];
    setProPhotos(newAddedPhotos);
  }

  return (
    <div className="main_wrp">
      <div className="main_page_wrp">
        <div className="head_wrp">
          <h5>
            Update <em>Customer Price</em>
          </h5>
        </div>
        <div className="main_body_wrp">
          <form onSubmit={handleSubmit}>
            <div className="add_main">
              <div className="add_t_form">
                <div className="in_main">
                  <label>Name</label>
                  <input
                    disabled
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </div>

                {/* <div className="in_main">
                  <label>Brand</label>
                  <select
                    value={selectBrand}
                    onChange={(e) => setSelectBrand(e.target.value)}
                  >
                    <option value="">-- Select Brand --</option>
                    {brandList.map((brand, i) => (
                      <option key={i} value={brand.brand}>
                        {brand.brand}
                      </option>
                    ))}
                  </select>
                </div> */}

                <div className="in_main">
                  <label>Category</label>
                  <select
                    disabled
                    value={selectCategory}
                    onChange={(e) => setSelectCategory(e.target.value)}
                  >
                    <option value="">-- Select Category --</option>
                    {categoryList.map((category) => (
                      <option key={category._id} value={category.category}>
                        {category.category}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="in_main">
                  <label>Type</label>
                  <select
                    disabled
                    value={selectType}
                    onChange={(e) => setSelectType(e.target.value)}
                  >
                    <option value="">-- Select Type --</option>
                    {typeList.map((type, i) => (
                      <option key={i} value={type}>
                        {type}
                      </option>
                    ))}
                  </select>
                </div>

                {/* <div className="in_main">
                  <label>Flash Sale</label>
                  <select
                    value={flashSale}
                    onChange={(e) => setFlashSale(e.target.value)}
                  >
                    <option value="">-- Select Yes or No --</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                </div> */}

                {/* <div className="in_main">
                  <label>Old Price</label>
                  <input
                    type="number"
                    value={oldPrice}
                    onChange={(e) => setOldPrice(e.target.value)}
                  />
                </div> */}

                {/* <div className="in_main">
                  <label>Stock</label>
                  <input
                    type="number"
                    value={stock}
                    onChange={(e) => setStock(e.target.value)}
                    required
                  />
                </div> */}

                <div className="in_main">
                  <label>Bar Code</label>
                  <input
                    disabled
                    type="text"
                    value={barCode}
                    onChange={(e) => setBarCode(e.target.value)}
                  />
                </div>

                <div className="in_main">
                  <label>Item Code</label>
                  <input
                    disabled
                    type="text"
                    value={lrCode}
                    onChange={(e) => setLrCode(e.target.value)}
                  />
                </div>

                {/* <div className="in_main">
                  <label>Discount (%)</label>
                  <input
                    type="number"
                    value={discount}
                    onChange={(e) => setDiscount(e.target.value)}
                  />
                </div> */}
                {/* <div className="in_main">
                  <label>Out of Stock </label>
                  <input
                    type="checkbox"
                    checked={outofstock}
                    onChange={(e) => setOutofstock(e.target.checked)}
                  />
                </div> */}
                <div className="in_main">
                  <label>Price (CTN) </label>
                  <input
                    type="number"
                    value={price}
                    disabled
                    onChange={(e) => setPrice(e.target.value)}
                    required
                  />
                </div>
                <div className="in_main">
                  <label>Unit Of Measure Code</label>
                  <input
                    type="number"
                    value={uom}
                    disabled
                    placeholder={oldCustomerPrice?.unitOfMeasureCode}
                    className="input_border"
                    onChange={(e) => setUom(e.target.value)}
                    required
                  />
                </div>
                <div className="in_main">
                  <label>Customer Price</label>
                  <input
                    type="number"
                    disabled
                    className="input_border"
                    placeholder={oldCustomerPrice?.price}
                    value={newCustomerPrice}
                    onChange={(e) => setNewCustomerPrice(e.target.value)}
                    required
                  />
                </div>
              </div>

              <div className="in_main_long">
                <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
                  <div className="in_main">
                    <label>Weight</label>
                    <input
                      disabled
                      type="text"
                      value={weight}
                      onChange={(e) => setWeight(e.target.value)}
                    />
                  </div>
                  <div className="in_main">
                    <label>Per kg</label>
                    <input
                      disabled
                      type="text"
                      value={perKg}
                      onChange={(e) => setPerKg(e.target.value)}
                    />
                  </div>
                  <div className="in_main">
                    <label>Height</label>
                    <input
                      disabled
                      type="text"
                      value={height}
                      onChange={(e) => setHeight(e.target.value)}
                    />
                  </div>
                  <div className="in_main">
                    <label>Width</label>
                    <input
                      disabled
                      type="text"
                      value={width}
                      onChange={(e) => setWidth(e.target.value)}
                    />
                  </div>
                  <div className="in_main">
                    <label>Length</label>
                    <input
                      disabled
                      type="text"
                      value={length}
                      onChange={(e) => setLength(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              <div className="in_main_long">
                <label>Description</label>
                <textarea
                  disabled
                  value={description}
                  rows={5}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </div>
              <div className="in_main_long">
                <div className="h_photo_grid">
                  {proPhotos?.length > 0 &&
                    proPhotos.map((link) => (
                      <div className="h_img_over" key={link}>
                        <img
                          src={`${process.env.REACT_APP_DOC_VIEW_LINK}/` + link}
                          alt="mentora.lk"
                        />
                        {/* <div className="h_trash_icon">
                          <button onClick={(e) => removeDoc(e, link)}>
                            <IoTrashBin style={{ fontSize: "medium" }} />
                          </button>
                        </div>
                        <div className="h_star_icon">
                          <button onClick={(e) => selectMainPhoto(e, link)}>
                            {link === proPhotos[0] && (
                              <GoStarFill
                                style={{
                                  fontSize: "medium",
                                  color: "var(--orange)",
                                }}
                              />
                            )}
                            {link !== proPhotos[0] && (
                              <GoStar style={{ fontSize: "medium" }} />
                            )}
                          </button>
                        </div> */}
                      </div>
                    ))}
                </div>
                {/* <div className="img_uploader">
                  <div className="img_upload_wrp">
                    <input
                      className="uplodInput"
                      onChange={uploadPhoto}
                      type="file"
                      multiple
                    />
                    <div className="img_upload_wrp_data">
                      <MdOutlineFileUpload color="#5143d9" size={30} />
                      <p>Drop Photo here or click to upload.</p>
                    </div>
                  </div>
                </div> */}
              </div>

              <div>
                <button type="submit" className="btn_submit_form">
                  <span>Update</span>
                </button>
              </div>

              {error && <small style={{ color: "red" }}>{error}</small>}
              {success && (
                <small style={{ color: "green" }}>
                  Product added successfully!
                </small>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
export default EditCustomerPrice;
